import React from 'react';
import { Text } from '@clockout-dev/design-elements';
import { KpiCard, ToggleBarChart, CohortUsersDrawer } from '../../../common/analytics';
import {
    ENGAGEMENT_SUMMARY_SERIES,
    USAGE_KPI_ICONS,
    USER_ADOPTION_FREQUENCIES,
} from '../../dashboard.constants';
import CardSkeleton from '../../../common/cardSkeleton/CardSkeleton';
import styles from './styles/engagement-section.module.scss';

function EngagementSection({
    kpis = [],
    engagementSummary,
    engagementSummaryMetrics = {},
    onEngagementSummaryFrequencyChange,
    userSessions,
    cohort = {},
    loading = false,
}) {
    const {
        activeFrequency = 'monthly',
        data = {},
        loading: chartLoading = false,
    } = engagementSummaryMetrics;
    const chartDataLoading = chartLoading && data[activeFrequency] === undefined;

    return (
        <section className={styles.section}>
            <Text as="span" size="xs" className={styles.sectionLabel}>Engagement</Text>

            {loading ? (
                <>
                    <div className={styles.kpiRow}>
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                        <CardSkeleton minHeight={150} rows={1} />
                    </div>
                    <div className={styles.chartsRow}>
                        <CardSkeleton minHeight={420} rows={6} />
                        <CardSkeleton minHeight={420} rows={6} />
                    </div>
                </>
            ) : (
                <>
            <div className={styles.kpiRow}>
                {kpis.map((kpi) => (
                    <KpiCard
                        key={kpi.key}
                        label={kpi.label}
                        value={kpi.value}
                        variant={kpi.variant}
                        conversionRate={kpi.conversionRate}
                        icon={USAGE_KPI_ICONS[kpi.key]}
                        onClick={kpi.drilldown && cohort.onOpen ? () => cohort.onOpen(kpi.drilldown) : undefined}
                    />
                ))}
            </div>

            <div className={styles.chartsRow}>
                <ToggleBarChart
                    title={engagementSummary.title}
                    subtitle={engagementSummary.subtitle}
                    toggles={USER_ADOPTION_FREQUENCIES}
                    activeToggle={activeFrequency}
                    onToggleChange={onEngagementSummaryFrequencyChange}
                    series={ENGAGEMENT_SUMMARY_SERIES}
                    data={data}
                    loading={chartDataLoading}
                />
                <ToggleBarChart
                    title={userSessions.title}
                    subtitle={userSessions.subtitle}
                    toggles={USER_ADOPTION_FREQUENCIES}
                    defaultToggle="monthly"
                    series={userSessions.series}
                    data={userSessions.data}
                    showLegend={false}
                />
            </div>
                </>
            )}

            <CohortUsersDrawer cohort={cohort} />
        </section>
    );
}

export default EngagementSection;
